import { render, staticRenderFns } from "./Job_Details.vue?vue&type=template&id=72bf9078&"
import script from "./Job_Details.vue?vue&type=script&lang=js&"
export * from "./Job_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports